//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbLoginPanel from '@/elements/login-register/rb-login-panel.vue'
import RbLoginModal from '@/elements/login-register/rb-login-modal.vue'
import RbPanel from '@/elements/panel/rb-panel.vue'

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import wcs from '@/scripts/libs/wcs'

export default {
  name: 'rb-login-panel-and-modal',
  components: {
    RbLoginPanel,
    RbLoginModal,
    RbPanel,
  },
  props: {
    fromFrameAdvisor: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loginFormIsVisible: true,
    }
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    getLoginModalWrapperClass() {
      return wcs.isInPdp() ? 'main' : 'footer'
    },
  },
  methods: {
    closeLogin() {
      this.$emit('closed')
    },
  },
}
